import { RefundReleaseUserLiteModel } from 'api-hooks/refund/refund-release-user';
import { NavigationRoutes } from 'common/constants';
import { PaginationMeta } from 'common/repositories/common.model';
import PaginationComponent from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import { TableContainer } from 'legacy-modules/styles';
import * as React from 'react';

interface Props {
  refundReleaseUser: RefundReleaseUserLiteModel[];
  loading?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  meta?: PaginationMeta;
  sortColumns: IColumn<RefundReleaseUserLiteModel>[];
}

export default function RefundReleaseUserTable(props: Props) {
  const { refundReleaseUser, sortColumns, loading, page, onPageChange, meta } =
    props;

  const permission = useGetCrudPermission('release-sales');

  const columns = React.useMemo<IColumn<any>[]>(
    () => [
      {
        header: '#',
        accessorKey: 'index',
        stickyLeft: true,
        minSize: 40,
        size: 40,
        maxSize: 40,
        cell: ({ row }) => {
          return (
            <>
              {row.index +
                1 +
                ((meta?.currentPage || 1) - 1) * (meta?.perPage || 1)}
            </>
          );
        },
      },
      ...sortColumns,
    ],
    [meta?.currentPage, meta?.perPage, sortColumns],
  );

  return (
    <>
      <TableContainer>
        <TableComponent
          columns={columns}
          isLoading={loading}
          data={refundReleaseUser || []}
          rowLink={(row) => {
            if (!permission.view) return undefined;
            return {
              pathname: NavigationRoutes.RefundReleaseUserView,
              query: {
                id: row.original.id,
              },
            };
          }}
        />
      </TableContainer>
      <PaginationComponent
        page={page}
        onPageChange={onPageChange}
        meta={meta}
      />
    </>
  );
}
